import { ReactNode } from 'react';
import { IControlProps, IPartialFormGroup } from '../types';
import FormControl from '../FormControl';
import TimeField, { ITimeFieldProps } from '../../atoms/TimeField';
import { useHookFormController } from '../../hooks/useHookFormController';

export type ITimeFieldControlProps = Omit<ITimeFieldProps, 'value' | 'onChange' | 'defaultValue'> &
    IControlProps & {
        formGroupProps?: IPartialFormGroup;
        label?: ReactNode;
        tooltip?: ReactNode;
        required?: boolean;
        onValueChange?: (value: string) => void;
    };

const TimeFieldControl = ({
    name,
    rules,
    defaultValue,
    control,
    shouldUnregister,
    label,
    tooltip,
    required,
    formGroupProps,
    onValueChange,
    readOnly,
    ...props
}: ITimeFieldControlProps) => {
    const Controller = useHookFormController();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultValue}
            render={({ field: { onChange, value, ...fieldProps } }) => (
                <FormControl
                    readonlyAppearance={readOnly || props.disabled ? 'field' : undefined}
                    name={name}
                    label={label}
                    tooltip={tooltip}
                    required={required}
                    control={control}
                    {...formGroupProps}
                >
                    <TimeField
                        {...fieldProps}
                        {...props}
                        readOnly={readOnly}
                        value={value ?? ''}
                        onChange={(next) => {
                            if (readOnly) return;
                            if (next === value) return;
                            onChange(next);
                            if (onValueChange) onValueChange(next);
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default TimeFieldControl;
